import { useEffect } from 'react';
import { isMobile } from 'react-device-detect';

export default function useTypeToSearch({ caixaSelected, setNameSearch, setShowBuscar, openLlista }) {
    useEffect(() => {
        if (isMobile || caixaSelected === -1) return;
        const startSearch = event => {
            if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey || event.isComposing) return;
            if (event.key?.length !== 1) return;
            if (document.querySelector('dialog[open], [data-board-confirmation], [aria-modal="true"]')) return;
            if (event.target.closest?.('button, input, select, textarea, [role="button"], [contenteditable]:not([contenteditable="false"])')) return;

            // Capture the first character before the input mounts and takes focus.
            // Later characters use the input's normal editing behaviour.
            event.preventDefault();
            setNameSearch(previous => previous + event.key);
            setShowBuscar(true);
            openLlista?.();
        };
        document.addEventListener('keydown', startSearch);
        return () => document.removeEventListener('keydown', startSearch);
    }, [caixaSelected, setNameSearch, setShowBuscar, openLlista]);
}
